import { actions, reducer } from './categorySlice';
import { selectors } from './selectors';
import getProductsForCategory from './actionsAsync';

const api = { getProductsForCategory };
export { actions, reducer, api, selectors };
export default reducer;
